<template>
  <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_12554_92769)">
      <g clip-path="url(#clip1_12554_92769)">
        <g clip-path="url(#clip2_12554_92769)">
          <path d="M0 7.7998H19V11.9998H0V7.7998Z" fill="#FFCE00"/>
          <path d="M0 0H19V4.2H0V0Z" fill="black"/>
          <path d="M0 4.2002H19V7.8002H0V4.2002Z" fill="#DD0000"/>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_12554_92769">
        <rect width="19" height="12" fill="white"/>
      </clipPath>
      <clipPath id="clip1_12554_92769">
        <rect width="19" height="12" fill="white"/>
      </clipPath>
      <clipPath id="clip2_12554_92769">
        <rect width="19" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'FlagDE',
}
</script>
